import React, { useEffect, useContext } from 'react';

export const SampleDetailPage = (props) => {
  return (
    <article className='sample-page'>
      <span>sample detail</span>
    </article>
  );
};
